import { Validator } from "../Validator";

export class Email extends Validator {
    public validate(value: any, opt: any): boolean {
        return /^[a-z\d][a-z\d.\-_]*@[a-z\d]{1,}\.[a-z\d]*[a-z\d]$/i.test(value);
    }
}
